import i18n from 'i18next';

import { AeroexpressDirection, AeroexpressSelectedTrip } from '@websky/graphql';
import { getAeroexpressTripLabel } from '../../../CheckoutAdditionalService/utils';

export function getAeroexpressName(selectedTrip: AeroexpressSelectedTrip): string {
	let direction: string[];
	const fromDirection = selectedTrip.fromStation.direction;

	if (fromDirection === AeroexpressDirection.FromAirport) {
		direction = [
			i18n.t(`Aeroexpress:${fromDirection}`, { ns: 'Checkout ' }),
			i18n.t(`Aeroexpress:${selectedTrip.toStation.name}`, { ns: 'Checkout' })
		];
	} else if (fromDirection === AeroexpressDirection.ToAirport) {
		direction = [
			i18n.t(`Aeroexpress:${selectedTrip.fromStation.name}`, { ns: 'Checkout ' }),
			i18n.t(`Aeroexpress:${fromDirection}`, { ns: 'Checkout ' })
		];
	} else {
		direction = [i18n.t(`Aeroexpress:${selectedTrip.fromStation.name}`, { ns: 'Checkout ' })];
	}

	return `${getAeroexpressTripLabel(selectedTrip)} ${direction.join(' – ')}, ${i18n.t(`Class_${selectedTrip.class}`, {
		ns: 'Checkout'
	})}`;
}
